
export class DHQDeptModel {
    
    Id: any;
    DepartmentName: any;
    TypeCode: any;
    IsActive:any;
    
}